import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15daf722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-line" }
const _hoisted_2 = { class: "title" }

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'label-title-wrap',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})